const STORAGE_KEY = "trackvan_report_usage";

export interface ReportUsage {
  [reportId: string]: number;
}

/**
 * Get all report usage data from localStorage
 */
export const getReportUsage = (): ReportUsage => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as ReportUsage;
    }
  } catch (e) {
    console.error("Failed to parse report usage data", e);
  }
  return {};
};

/**
 * Track a report view - increments the usage count for the given report ID
 * @param reportId - The unique identifier for the report
 */
export const trackReportUsage = (reportId: string): void => {
  try {
    const usage = getReportUsage();
    usage[reportId] = (usage[reportId] || 0) + 1;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(usage));
  } catch (e) {
    console.error("Failed to track report usage", e);
  }
};

/**
 * Get usage count for a specific report
 * @param reportId - The unique identifier for the report
 */
export const getReportUsageCount = (reportId: string): number => {
  const usage = getReportUsage();
  return usage[reportId] || 0;
};

/**
 * Get top N most used reports
 * @param limit - Maximum number of reports to return (default: 5)
 */
export const getTopReports = (limit: number = 5): Array<{ id: string; count: number }> => {
  const usage = getReportUsage();
  return Object.entries(usage)
    .filter(([, count]) => count > 0)
    .sort(([, a], [, b]) => b - a)
    .slice(0, limit)
    .map(([id, count]) => ({ id, count }));
};

/**
 * Clear all report usage data
 */
export const clearReportUsage = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
